import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import { StatusCode } from '@/constants'
import { useCommonForm } from '@/hooks'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const HealthCertificate: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const {
    staff_id,
    runDeleteHrmContact,
    runSaveContact,
    deleteHrmContactLoading,
    saveContactLoading,
    status,
    editItem
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm }, setState] = useSetState<any>({
    randomForm: null
  })
  console.log('status----editItem', status, editItem)
  const onFinish = (fieldValues: any) => {
    if (deleteHrmContactLoading || saveContactLoading) return
    const values_info = {
      ...fieldValues,
      id: editItem?.id || null,
      employee_id: staff_id || null
    }
    runSaveContact(values_info)
  }

  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const rowInfo = {
        ...editItem
      }
      formIt.setFieldsValue(rowInfo)

      setState({ randomForm: Math.random() })
    }
    setFieldValues(status === 'Edit')
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const fields = editItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteHrmContact(ids)
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }
  const { option, optionStatus } = useCommonForm({
    code: 'emergency_contact_from',
    vars: {},
    immediate: true
  })
  if (option?.formInfo?.[0]) {
    option.formInfo[0].is_show_title = true
  }
  return (
    <HPopup
      title='紧急联系人'
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      {optionStatus === StatusCode.done && (
        <div className='income-tax-declaration-popup'>
          <NewEditForm
            formInst={formIt}
            formInfo={option?.formInfo ?? []}
            onFinish={onFinish}
            randomForm={randomForm}
            formButtons={getFormButtons(modalData?.status === 'Edit')}
          />
        </div>
      )}
    </HPopup>
  )
}

export default HealthCertificate
